import { cn } from "../../utils/classNames";

const options = [
  { key: "loved", label: "Love It", icon: "♥", className: "border-green-400 text-green-300 shadow-[0_0_20px_rgba(74,222,128,0.25)]" },
  { key: "meh", label: "Meh", icon: "●", className: "border-hookd-gold text-hookd-gold shadow-gold" },
  { key: "nah", label: "Nope", icon: "×", className: "border-hookd-neon text-hookd-neon shadow-neon" },
];

export default function FeedbackButtons({
  selected,
  disabled = false,
  onFeedback,
  compact = false,
}) {
  return (
    <div className={cn("grid grid-cols-3 gap-3", compact ? "max-w-xs" : "")}>
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          onClick={() => onFeedback?.(option.key)}
          disabled={disabled}
          className={cn(
            "group flex flex-col items-center justify-center gap-2 rounded-hookd border bg-white/5 p-3 text-xs font-bold uppercase transition",
            "hover:-translate-y-0.5 disabled:cursor-wait disabled:opacity-50",
            selected === option.key ? option.className : "border-white/10 text-hookd-muted hover:border-hookd-empress/60 hover:text-hookd-cream"
          )}
        >
          <span
            className={cn(
              "flex h-10 w-10 items-center justify-center rounded-full border text-2xl",
              selected === option.key ? option.className : "border-white/10"
            )}
          >
            {option.icon}
          </span>
          {option.label}
        </button>
      ))}
    </div>
  );
}
